<script lang="ts">
  import clsx from 'clsx'
  import videoStore from '../../../stores/video.svelte'

  function onClick() {
    if (!videoStore.isLive() && videoStore.state.liveSyncPosition) {
      videoStore.state.videoController?.setCurrentTime(
        videoStore.state.liveSyncPosition,
      )
      if (!videoStore.state.isPlaying) {
        videoStore.state.videoController?.play()
      }
    }
  }
</script>

<button
  class={clsx('flex justify-center items-center gap-2', {
    'cursor-default': videoStore.isLive(),
  })}
  onclick={() => onClick()}
  onkeydown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
>
  <!-- red dot -->
  <div
    class={clsx(
      'w-2 h-2  rounded-full',
      videoStore.isLive() ? 'bg-red-500' : 'bg-slate-600',
    )}
  ></div>
  <p class="text-white uppercase text-xs">live</p>
</button>
